<template>
	<div :style="{'height': height, 'width': width}" @click="show" style="cursor: pointer">
		<v-menu 
			origin="center center"
			transition="scale-transition"
			bottom
			offset-y
			absolute
			v-model="showMenu"
			:position-x="x"
			:position-y="y"
		>
			<!-- <button type="button" slot="activator" title="Add to Calendar" class="" style="width: 100%; height: 100%;">
				<v-icon medium>fal fa-calendar-plus</v-icon>
			</button> -->
			<v-list>
				<v-list-tile v-for="item in calendars" :key="item.text" @click="select(item)">
					<v-list-tile-title>{{ item.text }}</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
import moment from 'moment'
import { ics } from '~/plugins/ics'

export default {
	name: 'addToCalendar',
	props: [
		'height',
		'width',
		'title',
		'date',
		'startTime',
		'endTime',
		'description',
		'location'
	],
	data() {
		return {
			showMenu: false,
			x: 0,
			y: 0,
			calendars: [
				{
					text: 'Google',
					id: 'google',
					url: 'http://www.google.com/calendar/event?'
				},
				{
					text: 'Outlook',
					id: 'microsoft',
					url: 'http://calendar.live.com/calendar/calendar.aspx?rru=addevent&'
				},
				{
					text: 'Yahoo',
					id: 'yahoo',
					url: 'http://calendar.yahoo.com/?v=60&'
				},
				{
					text: 'Apple',
					id: 'apple',
					url: ''
				}
			]
		}
	},
	methods: {
		show(e) {
			e.preventDefault()
			this.showMenu = false
			this.x = e.clientX
			this.y = e.clientY
			this.$nextTick(() => {
				this.showMenu = true
			})
		},
		select(calendar) {
			let url
			let urlTitle = encodeURIComponent(this.title)
			let urlDescription = encodeURIComponent(this.description)
			let urlLocation = encodeURIComponent(this.location)
			let urlRedirect = encodeURIComponent('http://staging.wrkprty.com') // Change!

			if (calendar.id === 'microsoft' || calendar.id === 'apple') {
				let startDate = moment(this.date + ' ' + this.startTime).format(
					'MM/DD/YYYY h:mm:ss a'
				)
				let endDate = moment(this.date + ' ' + this.endTime).format(
					'MM/DD/YYYY h:mm:ss a'
				)
				let cal = ics()
				cal.addEvent(
					this.title,
					this.description,
					this.location,
					startDate,
					endDate
				)
				cal.download(this.title.replace(/ /g, '_'))
			} else if (calendar.id === 'google') {
				let startDate = moment(this.date + ' ' + this.startTime).format(
					'YYYYMMDDTHHmmss'
				)
				let endDate = moment(this.date + ' ' + this.endTime).format(
					'YYYYMMDDTHHmmss'
				)
				let date = startDate + '/' + endDate
				url =
					calendar.url +
					`action=TEMPLATE&dates=${date}&text=${urlTitle}&details=${urlDescription}&location=${urlLocation}&sprop=website:www.wrkprty.com&sprop=name:wrkprty`
			} else if (calendar.id === 'yahoo') {
				let startDate = moment(this.date + ' ' + this.startTime).format(
					'YYYYMMDDTHHmmss'
				)
				let startTime = moment(this.date + ' ' + this.startTime)
				let endTime = moment(this.date + ' ' + this.endTime)
				let dateDiff = moment.duration(endTime.diff(startTime))
				let hours = String('0' + dateDiff.asHours()).slice(-2)
				let duration = hours + '00'

				url =
					calendar.url +
					`ST=${startDate}&DUR=${duration}&TITLE=${urlTitle}&DESC=${urlDescription}&in_loc=${urlLocation}&URL=${urlRedirect}`
			}
			if (url) {
				window.open(
					url,
					'wrkprty ' + calendar.text,
					'height=480,width=640',
					'_blank'
				)
			}
		}
	}
}
</script>
